import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/FOTA/FOTAWeb/FOTAmanager/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from "./res_zh";
import en from "./res_en";
import elementZh from 'element-ui/lib/locale/lang/zh-CN';
import elementEn from 'element-ui/lib/locale/lang/en';
Vue.use(VueI18n);
var lang = navigator.language || navigator.browserLanguage;

if (lang.toLowerCase().indexOf('zh') !== -1) {
  lang = 'zh';
} else {
  lang = 'en';
}

if (localStorage.getItem('lang')) {
  lang = localStorage.getItem('lang');
}

var i18n = new VueI18n({
  locale: lang,
  messages: {
    zh: _objectSpread(_objectSpread({}, zh), elementZh),
    en: _objectSpread(_objectSpread({}, en), elementEn)
  }
});
export default i18n;